module.exports = __webpack_public_path__ + "img/1.e61bec08.png";